/**
 * AuthGuard Component
 * Protects routes that require authentication
 */

import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';

import { useAuthStore } from '@/store/authStore';
import { checkAuth } from '@/data/auth';
import { useColors } from '@ai-content-hub/hooks';

interface AuthGuardProps {
    children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
    const location = useLocation();
    const colors = useColors();
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const isCheckingAuth = useAuthStore((s) => s.isCheckingAuth);

    // Check auth on mount
    useEffect(() => {
        void checkAuth();
    }, []);

    // Show loading while checking auth
    if (isCheckingAuth) {
        return (
            <div
                className="auth-loading"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    background: colors.background,
                }}
            >
                <Spin size="large" />
            </div>
        );
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default AuthGuard;

